import React, { useState, useEffect } from "react";
import TurnstileWidget from "./TurnstileWidget";

const ShopFormular = ({ data, onSubmittedChange, isParentSubmitted }) => {
  const [isSent, setIsSent] = useState(false);

  // Check if this specific form was already submitted (page refresh scenario)
  useEffect(() => {
    const formSubmitted = sessionStorage.getItem(`form-submitted-${data.slug}`);
    if (formSubmitted) {
      setIsSent(true);
      // Notify parent component about initial state
      if (onSubmittedChange) {
        onSubmittedChange(true);
      }
    }
  }, [data.slug, onSubmittedChange]);

  const formSubmit = (e) => {
    e.preventDefault();
    const form = document.querySelector(`#shopformular-${data.slug}`);
    const formData = new URLSearchParams(new FormData(form));
    
    fetch(process.env.GATSBY_FORM_ACTION, {
      method: "post",
      body: formData,
    });
    
    // Mark this specific form as submitted
    sessionStorage.setItem(`form-submitted-${data.slug}`, 'true');
    setIsSent(true);
    // Notify parent component about submission
    if (onSubmittedChange) {
      onSubmittedChange(true);
    }
  };
  
  // Don't show ShopFormular's own thank you message if parent is already showing "already bought"
  if (isParentSubmitted) {
    return null;
  }
  
  return isSent ? (
    <div className="submitted-form-message">
      <h2 className="shopBodyTitle">Vielen Dank für Ihre Bestellung</h2>
      <p className="shopBodyParagraph">Ihre Bestellung wurde erfolgreich übermittelt.</p>
    </div>
  ) : (
    <>
      <form
        className={`shopformular mura-form-builder shopformular-${data.slug}`}
        action={process.env.GATSBY_FORM_ACTION}
        id={`shopformular-${data.slug}`}
        method="post"
        acceptCharset="utf-8"
        onSubmit={formSubmit}
      >
        <input
          name="recipient"
          type="hidden"
          value={process.env.GATSBY_FORM_RECIPIENT}
        />
        <input type="hidden" name="titel" value="" readOnly />
        <input type="hidden" name="isbn" value="" readOnly />
        <input
          type="hidden"
          name="preis"
          value={data.preis.toFixed(2)}
          readOnly
        />
        <div className="mura-form-textfield req ">
          <label htmlFor="vorname">
            Vorname <ins>Required</ins>
          </label>
          <input type="text" name="vorname" required />
        </div>
        <div className="mura-form-textfield req ">
          <label htmlFor="name">
            Name <ins>Required</ins>
          </label>
          <input type="text" name="name" required />
        </div>
        <div className="mura-form-textfield req ">
          <label htmlFor="email">
            E-Mail <ins>Required</ins>
          </label>
          <input type="text" name="email" required />
        </div>
        <div className="mura-form-textarea req">
          <label htmlFor="adresse">
            Adresse <ins>Required</ins>
          </label>
          <textarea rows={5} name="adresse" required></textarea>
        </div>
        <input
          type="hidden"
          value="Dichter Stauffer Bestellformular"
          name="subject"
        />
        <div>
          <br />
          <input type="submit" value="senden" />
          <br />
          <TurnstileWidget siteKey={process.env.GATSBY_FORM_TURNSTILE_SITE_KEY} widgetId={data.slug}/>
        </div>
      </form>
    </>
  );
};

export default ShopFormular;
